"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formCoupler = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _assign2 = _interopRequireDefault(require("lodash/assign"));
var _cccisdFormik = require("cccisd-formik");
var _ImagePicker = _interopRequireDefault(require("../ImagePicker"));
var _helpers = require("../helpers");
var _navigations = require("../../navigations");
var _SurveySelector = _interopRequireDefault(require("./SurveySelector"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = {
  toggle: false,
  tabName: 'Course Evaluation',
  navigation: 'noSidebar',
  lockedUntilCompletion: true,
  options: []
};
var validate = function validate(values, errors) {
  var localErrors = {};
  if (values.courseEval.toggle) {
    if (!values.courseEval.tabName) {
      localErrors['courseEval.tabName'] = 'Course Evaluation Tab Name is required';
    }
    if (values.courseEval.options.length === 0) {
      localErrors['courseEval.options'] = 'You must select at least one Course Evaluation survey';
    }
  }
  (0, _assign2["default"])(errors, localErrors);
  return !Object.keys(localErrors).length;
};
var formCoupler = {
  initialValues: initialValues,
  validate: validate,
  errorTab: 'postCourse',
  key: 'courseEval'
};

/* Main Component */
exports.formCoupler = formCoupler;
var FormCourseEval = function FormCourseEval(_ref) {
  var assignmentData = _ref.assignmentData,
    toggle = _ref.toggle,
    formProps = _ref.formProps;
  var questSettings = assignmentData.settings,
    currentSurveylistList = assignmentData.currentSurveylistList;
  var renderToggleField = function renderToggleField() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseEval.toggle",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Use Course Evaluation Tab",
        tooltip: "Have users evaluate the course after they have finished the Final Test; otherwise, after they have completed the Course."
      })
    }));
  };
  var renderConditionalFields = function renderConditionalFields() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseEval.tabName",
      component: _cccisdFormik.CccisdInput,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Course Evaluation Tab Name",
        tooltip: "The text for Course Evaluation in the tab bar"
      })
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseEval.lockedUntilCompletion",
      component: _cccisdFormik.CccisdToggle,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Locked Until Course Completion",
        tooltip: "Only allow users to take Course Evaluation after required Course surveys are complete (and Final Test, if applicable)."
      })
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseEval.options",
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Course Evaluation Surveys",
        tooltip: "Select the survey(s) representing the Course Evaluation."
      }),
      component: _SurveySelector["default"],
      surveyList: currentSurveylistList.surveyList
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-info",
      style: {
        paddingBottom: 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseEval.navigation",
      label: "Navigation for Course Evaluation",
      component: _ImagePicker["default"],
      options: (0, _navigations.getNavigations)({
        noCurriculum: true,
        noCourseWrapper: true,
        requiredNavigation: (0, _get2["default"])(formProps, 'initialValues.courseEval.navigation')
      }),
      questSettings: questSettings,
      height: "98px",
      settingsFieldName: "courseEval.navigationSettings"
    })));
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h3", null, "Course Evaluation"), renderToggleField(), toggle && renderConditionalFields());
};
var _default = FormCourseEval;
exports["default"] = _default;